import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { TaskModel } from 'app/models/dms/tasksSearchResult.model';
import { UserService } from 'app/services/user.service';
import { SecurityRight } from 'app/utility/enums';

@Component({
    template: `
        <ion-list lines="none" class="ion-no-margin" inset="false" mode="md">
            <ion-item (click)="performAction('dismissAll')">
                <ion-label>Dismiss all</ion-label>
            </ion-item>               
        </ion-list>
        `,
    standalone: false
})

export class RemindersPopover implements OnInit
{
    constructor(
        private popoverCtrl: PopoverController,
    ) { }

    ngOnInit(): void
    {

    }

    async onDismiss()
    {
        try
        {
            await this.popoverCtrl.dismiss();
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    async performAction(action: string)
    {
        try
        {
            await this.popoverCtrl.dismiss(action);
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    public hasPermission(action: string): boolean
    {
        switch (action)
        {
            default:
                return true;
                break;
        }
    }
}